import React from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';

function TaxRevenueInformation({ data }) {
  return (
    <div className="col-12 form-group border rounded p-2">
      <label>License</label>
      <small className="p-2">
        <table className="transaction-table table table-borderless table-sm">
          <tbody>
            <tr>
              <td className="text-dark" width="150">
                Code
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>{get(data, 'included.license.attributes.code')}</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" width="150">
                Name
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>{get(data, 'included.license.attributes.name')}</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" width="150">
                Description
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>{get(data, 'included.license.attributes.description')}</b>
              </td>
            </tr>
          </tbody>
        </table>
      </small>
      <hr />
      <label>Permit</label>
      <small className="p-2">
        <table className="transaction-table table table-borderless table-sm">
          <tbody>
            <tr>
              <td className="text-dark" width="150">
                Code
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>{get(data, 'included.permit.attributes.code')}</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" width="150">
                Name
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>{get(data, 'included.permit.attributes.name')}</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" width="150">
                Description
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>{get(data, 'included.permit.attributes.description')}</b>
              </td>
            </tr>
          </tbody>
        </table>
      </small>
      <hr />
      <label>Sanitary</label>
      <small className="p-2">
        <table className="transaction-table table table-borderless table-sm">
          <tbody>
            <tr>
              <td className="text-dark" width="150">
                Code
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>{get(data, 'included.sanitary.attributes.code')}</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" width="150">
                Name
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>{get(data, 'included.sanitary.attributes.name')}</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" width="150">
                Description
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>{get(data, 'included.sanitary.attributes.description')}</b>
              </td>
            </tr>
          </tbody>
        </table>
      </small>
      <hr />
      <label>Garbage</label>
      <small className="p-2">
        <table className="transaction-table table table-borderless table-sm">
          <tbody>
            <tr>
              <td className="text-dark" width="150">
                Code
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>{get(data, 'included.garbage.attributes.code')}</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" width="150">
                Name
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>{get(data, 'included.garbage.attributes.name')}</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" width="150">
                Description
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>{get(data, 'included.garbage.attributes.description')}</b>
              </td>
            </tr>
          </tbody>
        </table>
      </small>
    </div>
  );
}

TaxRevenueInformation.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
};

export default TaxRevenueInformation;
